import { MapMarkerSelectType } from "@common/types";

const regexStringSelected = 'class=\\"[\\d\\s\\w\\-\\_]*' + MapMarkerSelectType.Selected + '[\\d\\s\\w\\-\\_]*\\"';
const regexStringPartiallySelected = 'class=\\"[\\d\\s\\w\\-\\_]*' + MapMarkerSelectType.PartiallySelected + '[\\d\\s\\w\\-\\_]*\\"';
export const regexSelect = new RegExp(regexStringSelected, 'i');
export const regexPartiallySelected = new RegExp(regexStringPartiallySelected, 'i');